/**
 * creates Citizen Events object for use in various contexts e.g. Calendar, Referral

 * @returns citizen event object
 */
export const  getCitizenEvents = function() {
  let csrf = Util.getCSRF();
  let citizenEvents = {

    getEvents : function() {
      return '/get-events';
    },

    getAppointments : function(referralID) {
      
      return $.ajax({
        url: '/get-appointments',
        type: 'get',
        data: {
          referral_id : referralID
        }
      });
    },
    
    addEvent : function(form) {
      return PDS.pds.post('ds_events', form);
    },

    updateEvent : function(form, event) {
      return PDS.pds.update('ds_events', form, event);
    },

    deleteEvent : function(event) {
      return PDS.pds.delete('ds_events', event);
    },

    handleInvite : function(inviteStatus, eventID) {
      return $.ajax({
        url: '/manage-event-invite',
        type: 'put',
        data: {
          status : inviteStatus,
          event_id : eventID
        },
        headers: { 'x-csrf-token': csrf }
      });
    },

    modifyEventViewBasedOnStatus : function(status) {
      switch(status) {
        case "INVITED":
          $('#event-status-message').html("You have been invited by");
          $('#accept-invite').removeClass('d-none');
          $('#reject-invite').removeClass('d-none');
          break;
        case "CONFIRMED":
          $('#event-status-message').html("You have accepted this invite from");
          $('#reject-invite').removeClass('d-none');
          break;
        case "REJECTED":
          $('#event-status-message').html("You have rejected this invite from");
          $('#accept-invite').removeClass('d-none');
          $('#delete-event').removeClass('d-none');
          break;
        default:
          $('#delete-event').removeClass('d-none');
      }
    }

  };

  return citizenEvents;
}